.container {
  padding-bottom: 90px;
}

.image {
  object-fit: cover;
  width: 90px;
  height: 90px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.3);
}

.defaultImage {
  object-fit: contain;
}

.status {
  border-radius: 24px;
  padding: 12px 8px;
  width: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-content: center;
  gap: 12px;
}

.actionButton {
  width: 100%;
  margin-top: 8px;
}

.section {
  width: 100%;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-sizing: border-box;
}

.codeBox {
  width: 100%;
  padding: 16px 14px;
  border-radius: 16px;
  background: rgba(204, 255, 0, 0.1);
  border: 1px solid rgba(204, 255, 0, 0.4);
  box-sizing: border-box;
  text-align: center;
}

.code {
  font-family: monospace;
  font-size: 40px;
  letter-spacing: 8px;
  font-weight: 700;
}

.error {
  width: 100%;
  padding: 10px 14px;
  border-radius: 12px;
  background: rgba(255, 60, 60, 0.14);
  border: 1px solid rgba(255, 60, 60, 0.4);
  box-sizing: border-box;
}
